<template>
    <Vue3Lottie
        :animationData="animation"
        :loop="true"
        :autoplay="true"
        style="width: 500px; height: 500px; margin-top: -50px"
    />
</template>

<script setup>
import { defineAsyncComponent } from 'vue'
import animation from '@src/assets/AnimationLoading.json'

// lottie-web (via vue3-lottie) sozinho pesa ~600KB — carregado sob demanda
// em vez de entrar no bundle principal, já que esta tela aparece no boot.
const Vue3Lottie = defineAsyncComponent(() => import('vue3-lottie').then(m => m.Vue3Lottie))
</script>
